import classNames from 'classnames';
import React from 'react'
import parser from 'html-react-parser'
import {
    section
  } from './Highlight1.module.css';
export default function Highlight1({data}) {
    const {highlight1Title, highlight1Image} = data
    return (
        <div
            className={section} id={highlight1Title.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}
            style={{ background: `url(${highlight1Image?.localFile?.publicURL}) center top no-repeat` }}
        >
            <div className='container'>
                <div className='row'>
                    <div className='col-md-12 text-center'>
                        <h2 className='heading-level-2 white-color'>
                            {highlight1Title && parser(highlight1Title)}
                        </h2>
                    </div>
                </div>
            </div> 
        </div>
    )
}
